export const forecastContainer = {
  boxShadow: 'none',
  border: '1px solid rgba(17, 35, 71, 0.1)',
  borderRadius: '5px',
  marginBottom: '30px',
  marginTop: '30px',
};
export const foreHeader = {
  display: 'flex',
  'justify-content': 'center',
  'align-items': 'center',
};
